export default {
  "content": "<title>Wallet</title><rect x=\"48\" y=\"144\" width=\"416\" height=\"288\" rx=\"48\" ry=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M368 320a32 32 0 1132-32 32 32 0 01-32 32z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};